import { createUseStyles } from 'react-jss';

export const addEditStockRequest = createUseStyles({
  container: {

  },
});
